import React,{useEffect,useState} from 'react'
import { Oval } from  'react-loader-spinner'
import Pagination from './Pagination';
import axios from 'axios'
function TrendingMovies() {

 const [movies,setMovies]=useState([]);
 const [pageNumber,UpdatePageNumber]=useState(1);
 const [hover,setHover]=useState('')
 const[favourites,setFavourites]=useState([]);


 const goAhead=()=>{
   UpdatePageNumber(pageNumber+1)
 }
 let add = (movie) => {
  let newArray = [...favourites, movie]
  setFavourites([...newArray])
  localStorage.setItem("imdb", JSON.stringify(newArray))
}

let del = (movie) => {
  let newArray = favourites.filter((m) => m.id !== movie.id)
  setFavourites([...newArray])
  localStorage.setItem("imdb", JSON.stringify(newArray))
}
 const goBack=()=>{
   if(pageNumber>1)
   UpdatePageNumber(pageNumber-1);
 }
  useEffect(()=>{
    let oldFav = localStorage.getItem("imdb");
    oldFav = JSON.parse(oldFav) || [];
    
     setFavourites(oldFav);
    axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=4622bea788550ade8391ab66ed1e6dcc&page=${pageNumber}`).then((res)=>{
      setMovies(res.data.results)
    })
  },[pageNumber])
  return (
    <>
<div className="">
    <div className="mt-8 font-bold text-xl md:text-2xl text-center">Trending Movies</div>
    {
      movies.length===0 ?
      <div className='flex justify-center mt-5'>
      <Oval
heigth="100"
width="100"
color='blue'
ariaLabel='loading'
/>
</div>
:     
  <div className="flex justify-center flex-wrap">
        {
        movies.map((movies)=>(     
               
           <div className={`bg-[url(https://image.tmdb.org/t/p/w500/${movies.backdrop_path})] bg-cover bg-center h-[25vh] w-[150px] md:h-[30vh] md:w-[220px] mt-3 mr-3 rounded-2xl flex items-end hover:scale-110 ease-out duration-300 relative`}  onMouseEnter={()=>setHover(movies.id)} onMouseLeave={()=>setHover('')}>
          {
            hover===movies.id &&<>{
             ! favourites.find((m)=>m.id===movies.id) ?
            <div className="absolute top-2 right-2 bg-gray-800 opacity-80 text-2xl rounded-2xl cursor-pointer text-white" onClick={()=>add(movies)}>🙄</div>
            :
            <div className="absolute top-2 right-2 bg-gray-800 opacity-80 text-2xl rounded-2xl cursor-pointer text-white"  onClick={()=>del(movies)}>❤️</div>
            }
            </>
          }
           <div className='text-xl md:text-2xl opacity-50 w-full bg-black text-white text-center rounded-xl '>{movies.title}</div>
            
        </div>
        ))
        }
        </div>  
    }   
</div>
<Pagination pageNumber={pageNumber}  goAhead={goAhead} goBack={goBack} />
    </>
  )
}

export default TrendingMovies